'use strict';

import { Dropdown } from './dropdown.js';

export class DropdownSharewidget extends Dropdown {
	constructor(component_key) {
		super(component_key);
	}
	add_events() {		
		jQuery(`.js-${this.id}`).on('mouseenter', () => {
			yalwa.basics.bem_modifier(this.$list, 'active', 'add');
			if (this.$list.find(`.js-${this.id}_option`).length) {
				yalwa.basics.bem_modifier(this.$list.find(`.js-${this.id}_option`), 'active', 'add');
			}
		});
		jQuery(`.js-${this.id}`).on('mouseleave', (event) => {
			this.close_all(event);
		});
		this.$selected.on('click', `.js-${this.id}_option`,
			this.selected_click_handler.bind(this)
		);
		this.$list.on('click', `.js-${this.id}_option`,
			this.option_click_handler.bind(this)
		);
		jQuery(`.js-${this.id}`).on('blur', this.close_all.bind(this));
	}
	option_click_handler(event) {
	
		const $clicked_option = jQuery(event.currentTarget);
	
		const $link = $clicked_option.find('a[href^="link:"]');
		const href = $link.attr('href');
	
		if (href) {
			event.preventDefault();
	
			const decoded_url = decodeURIComponent(href.replace('link:', ''));
	
			navigator.clipboard.writeText(decoded_url)
				.then(() => {
					this.close_all(event);
					yalwa.basics.toast({message: yalwa.v.lang.locanto_blog_share_URL_copied, type: 'success'})
				})
		}
	}
}
